import React, { useEffect, useState } from 'react';
import { Gift, Users, TrendingDown, Copy, Check } from 'lucide-react';
export const ReferralProgram = () => {
  const [referralCode, setReferralCode] = useState('');
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    // Generate dynamic referral code based on user
    // In a real app, this would come from the logged-in user's data
    const generateReferralCode = () => {
      const userId = localStorage.getItem('userId') || 'GUEST';
      const timestamp = Date.now().toString(36).toUpperCase();
      return `GELD-${userId}-${timestamp}`.slice(0, 15);
    };
    setReferralCode(generateReferralCode());
  }, []);
  const handleCopy = () => {
    navigator.clipboard.writeText(referralCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <section className="py-20 bg-gradient-to-br from-accent-50 to-primary-50" data-id="element-1068">
      <div className="container" data-id="element-1069">
        <div className="text-center mb-16" data-id="element-1070">
          <div className="inline-flex items-center gap-2 bg-white px-5 py-2 rounded-full text-sm font-semibold mb-6 shadow-md" data-id="element-1071">
            <Gift size={18} className="text-primary-600" data-id="element-1072" />
            <span className="text-primary-700" data-id="element-1073">Referral Rewards</span>
          </div>
          <h2 className="section-title" data-id="element-1074">Refer & Earn Rewards</h2>
          <p className="section-subtitle" data-id="element-1075">
            Share Geldhaus with your network and enjoy exclusive benefits when
            they take up a loan
          </p>
        </div>

        <div className="max-w-5xl mx-auto" data-id="element-1076">
          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-1077">
            {/* How It Works */}
            <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-primary-100" data-id="element-1078">
              <div className="flex items-center gap-3 mb-6" data-id="element-1079">
                <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center" data-id="element-1080">
                  <Users size={24} className="text-primary-600" data-id="element-1081" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-1082">
                  How It Works
                </h3>
              </div>

              <div className="space-y-6" data-id="element-1083">
                <div className="flex gap-4" data-id="element-1084">
                  <div className="flex-shrink-0 w-8 h-8 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-1085">
                    1
                  </div>
                  <div data-id="element-1086">
                    <h4 className="font-semibold text-gray-900 mb-1" data-id="element-1087">
                      Share Your Code
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-1088">
                      Share your unique referral code with friends, family, or
                      business contacts
                    </p>
                  </div>
                </div>

                <div className="flex gap-4" data-id="element-1089">
                  <div className="flex-shrink-0 w-8 h-8 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-1090">
                    2
                  </div>
                  <div data-id="element-1091">
                    <h4 className="font-semibold text-gray-900 mb-1" data-id="element-1092">
                      They Apply
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-1093">
                      Your referral uses your code when applying for any loan
                      product
                    </p>
                  </div>
                </div>

                <div className="flex gap-4" data-id="element-1094">
                  <div className="flex-shrink-0 w-8 h-8 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-1095">
                    3
                  </div>
                  <div data-id="element-1096">
                    <h4 className="font-semibold text-gray-900 mb-1" data-id="element-1097">
                      You Both Win
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-1098">
                      Get discounts on your next loan or reduced interest on
                      your current loan
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Your Rewards */}
            <div className="bg-gradient-to-br from-primary-600 to-primary-700 rounded-2xl p-8 shadow-xl text-white" data-id="element-1099">
              <div className="flex items-center gap-3 mb-6" data-id="element-1100">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center" data-id="element-1101">
                  <Gift size={24} data-id="element-1102" />
                </div>
                <h3 className="text-2xl font-bold" data-id="element-1103">Your Rewards</h3>
              </div>

              <div className="space-y-4 mb-8" data-id="element-1104">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4" data-id="element-1105">
                  <div className="flex items-center gap-3 mb-2" data-id="element-1106">
                    <TrendingDown size={20} data-id="element-1107" />
                    <h4 className="font-semibold" data-id="element-1108">Reduced Interest Rate</h4>
                  </div>
                  <p className="text-sm text-primary-100" data-id="element-1109">
                    Get up to 2% interest rate reduction on your current loan
                    for each successful referral
                  </p>
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4" data-id="element-1110">
                  <div className="flex items-center gap-3 mb-2" data-id="element-1111">
                    <Gift size={20} data-id="element-1112" />
                    <h4 className="font-semibold" data-id="element-1113">Next Loan Discount</h4>
                  </div>
                  <p className="text-sm text-primary-100" data-id="element-1114">
                    Earn discounts on processing fees for your next loan
                    application
                  </p>
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4" data-id="element-1115">
                  <div className="flex items-center gap-3 mb-2" data-id="element-1116">
                    <Users size={20} data-id="element-1117" />
                    <h4 className="font-semibold" data-id="element-1118">Unlimited Referrals</h4>
                  </div>
                  <p className="text-sm text-primary-100" data-id="element-1119">
                    No limit on how many people you can refer. The more you
                    refer, the more you save!
                  </p>
                </div>
              </div>

              {/* Referral Code */}
              <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6" data-id="element-1120">
                <p className="text-sm text-primary-100 mb-2" data-id="element-1121">
                  Your Unique Referral Code
                </p>
                <div className="flex items-center gap-3" data-id="element-1122">
                  <div className="flex-1 bg-white/10 rounded-lg px-4 py-3 font-mono text-xl font-bold" data-id="element-1123">
                    {referralCode || 'Loading...'}
                  </div>
                  <button onClick={handleCopy} className="bg-white text-primary-600 hover:bg-primary-50 p-3 rounded-lg transition-colors duration-200" title="Copy referral code" data-id="element-1124">
                    {copied ? <Check size={24} data-id="element-1125" /> : <Copy size={24} data-id="element-1126" />}
                  </button>
                </div>
                <p className="text-xs text-primary-100 mt-2" data-id="element-1127">
                  This code is unique to you and tracks all your referrals
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center" data-id="element-1128">
            <a href="/apply" className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-1129">
              Start Referring Today
            </a>
          </div>
        </div>
      </div>
    </section>;
};